import { ArrowBack, Visibility, VisibilityOff } from '@mui/icons-material';
import { Box, Paper, Typography, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ResetButton from '../../Common_Components/ResetButton';
import SaveButton from '../../Common_Components/SaveButton';
import CustomInputField from '../../Common_Components/CustomInputField';
import CustomSelectBox from '../../Common_Components/CustomSelectBox';
import axiosInstance from '../../axios/axios';
import { Toast } from '../../Common_Components/Toast';

const AddUser = () => {
    const navigate = useNavigate(); // Hook for navigation
    const { id } = useParams();
    const handleBackClick = () => {
        navigate(-1); // Navigate back to the previous page
    };

    // Form states
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [role, setRole] = useState(null);
    const [status, setStatus] = useState(null);
    const [roleOptions, setRoleoptions] = useState([]);
    const [passwordVisible, setPasswordVisible] = useState(false); // State to toggle password visibility

    const statusOptions = [
        { id: 1, label: 'Active' },
        { id: 0, label: 'Inactive' },
    ];

    useEffect(() => {
        const getUserRoles = async () => {
            const response = await axiosInstance.get('/users/listUserRole');
            const { success, userRoles } = response.data;
            if (success === true) {
                const res = userRoles && userRoles.map((val) => {
                    return { id: val.RL_ID, label: val.RL_Name };
                });
                setRoleoptions(res);
            } else {
                setRoleoptions([]);
            }
        };
        getUserRoles();
    }, []);

    useEffect(() => {
        const getuserDetl = async () => {
            const response = await axiosInstance.get(`/users/view/${id}`);
            const { success, user } = response.data;
            if (success === true) {
                setUsername(user.UD_userName);
                setName(user.UD_Name);
                setEmail(user.UD_Email);
                setAddress(user.UD_Address);
                const res = roleOptions && roleOptions.filter((val) => {
                    return Number(val.id) === Number(user.UD_role_id);
                });
                setRole(res?.[0]);
                setStatus(statusOptions.find((s) => Number(s.id) === Number(user.UD_Status)));
            }
        };
        if (id) {
            getuserDetl();
        }
    }, [id, roleOptions]);

    const handleValidation = () => {
        // Validation checks for each field
        if (!username) {
            Toast.warning('Username is required');
            return false;
        }
        if (!password && !id) {
            Toast.warning('Password is required');
            return false;
        }
        if (!name) {
            Toast.warning('Name is required');
            return false;
        }
        if (!email) {
            Toast.warning('Email is required');
            return false;
        }
        // Email format validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) {
            Toast.warning('Please enter a valid email address');
            return false;
        }

        if (!address) {
            Toast.warning('Address is required');
            return false;
        }
        if (!role) {
            Toast.warning('User role is required');
            return false;
        }
        if (!status) {
            Toast.warning('Status is required');
            return false;
        }

        return true; // Return true if no errors
    };

    const saveUser = async (e) => {
        e.preventDefault();

        // Validate before submitting
        if (!handleValidation()) return;

        const request = {
            UD_userName: username,
            UD_Password: password,
            UD_Name: name,
            UD_Email: email,
            UD_Address: address,
            UD_role_id: role?.id,
            UD_Status: status?.id,
        };

        try {
            const response = id
                ? await axiosInstance.post(`/users/edit/${id}`, request)
                : await axiosInstance.post('/users/add', request);

            const { success, message } = response.data;

            if (success) {
                Toast.success(message);
                navigate(-1);
            } else {
                Toast.warning(message);
            }
        } catch (error) {
            console.error('Error saving user:', error);
            Toast.error('Error saving user');
        }
    };
    //for reset form fields
    const ResetFields = () => {
        setUsername('')
        setPassword('')
        setName('')
        setEmail('')
        setAddress('')
        setRole(null)
        setStatus(null)
    }
    return (
        <Box display="flex" padding={2} flexDirection="column" minHeight="100vh">
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} flexWrap="wrap">
                <Box display="flex" alignItems="center" mb={{ xs: 2, md: 0 }}>
                    <ArrowBack
                        onClick={handleBackClick}
                        style={{
                            cursor: 'pointer',
                            marginRight: '8px',
                            marginBottom: '5px',
                            height: '34px',
                            width: '38px',
                            color: '#545454',
                        }}
                    />
                    <Typography
                        sx={{
                            fontFamily: 'Times New Roman',
                            fontWeight: '700',
                            fontSize: { xs: '24px', md: '32px' },
                            lineHeight: '36.8px',
                            color: '#545454',
                        }}
                    >
                        Add User
                    </Typography>
                </Box>
                <Box>
                    <ResetButton label="Reset" onClick={ResetFields} />
                    <SaveButton label="Save" onClick={saveUser} />
                </Box>
            </Box>

            <Paper elevation={3} sx={{ padding: { xs: 2, md: 4 } }}>
                <Box display="flex" flexDirection="row" flexWrap="wrap" gap={2} justifyContent="space-between">
                    <Box flexBasis={{ xs: '100%', md: '30%' }}>
                        <CustomInputField
                            label="Name"
                            fullWidth
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                    </Box>
                    <Box flexBasis={{ xs: '100%', md: '30%' }}>
                        <CustomInputField
                            label="Email"
                            fullWidth
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </Box>
                    <Box flexBasis={{ xs: '100%', md: '30%' }}>
                        <CustomInputField
                            label="Address"
                            fullWidth
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                        />
                    </Box>
                    <Box flexBasis={{ xs: '100%', md: '30%' }}>
                        <CustomInputField
                            label="Username"
                            fullWidth
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </Box>
                    {id ? null : (
                        <Box flexBasis={{ xs: '100%', md: '30%' }}>
                            <CustomInputField
                                label="Password"
                                fullWidth
                                type={passwordVisible ? 'text' : 'password'}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <IconButton
                                            onClick={() => setPasswordVisible(!passwordVisible)}
                                            edge="end"
                                        >
                                            {passwordVisible ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    ),
                                }}
                            />
                        </Box>
                    )}

                    <Box flexBasis={{ xs: '100%', md: '30%' }}>
                        <CustomSelectBox
                            label="Role"
                            options={roleOptions}
                            Value={role}
                            setValue={setRole}
                        />
                    </Box>
                    <Box flexBasis={{ xs: '100%', md: '30%' }}>
                        <CustomSelectBox
                            label="Status"
                            options={statusOptions}
                            Value={status}
                            setValue={setStatus}
                        />
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
};

export default AddUser;
